export default __webpack_public_path__ + "static/media/GoodMannersOnThePlayground_05.35935cea.png";